import { CASH_DISCOUNT_PAYMENT_TYPES } from '../components/payments/integrated-payment/integrated-payment-types.constant'

/**
 * Determine if a payment type is eligible for cash discounting.
 *
 * @param paymentTypeId The payment type id to evaluate.
 * @returns True if the payment type is eligible for cash discounting.
 */
export const isEligibleForCashDiscount = (paymentTypeId: number) =>
  CASH_DISCOUNT_PAYMENT_TYPES.includes(paymentTypeId)
